<template>
    <f-app-screen class="items-center text-white justify-between bg-gradient-to-b from-backdrop-default to-backdrop-1100">
        <div class="safe-area-top">
            <div class="mx-4 mt-12 tall:mt-16 text-center">
                <h1>{{$t('choose.language')}}</h1>
                <div class="text-slate-blue-100 text-base text-center leading-normal mt-3" v-html="$t('choose.language.subtitle')"></div>
            </div>
        </div>

        <div class="overflow-auto w-full flex-initial mt-8 tall:mt-10 mb-auto flex justify-center p-1">
            <div class="grid grid-cols-2 gap-3 tall:gap-4 ">
                <lang-item
                        v-for="lang in languages"
                        :key="lang.code"
                        :code="lang.code"
                        :name="lang.name"
                        class="rounded-lg"
                        :active="lang.code === selectedLanguage"
                        @click="selectLanguage(lang.code)"
                />
            </div>
        </div>

        <div class="p-4 w-full shrink-0">
            <div class="safe-area-bottom">
                <nav-button
                        color="green"
                        @click="setUserLanguage(selectedLanguage)"
                        :label="$t('tutorial2.button.continue')"
                />

                <p class="text-center my-4 tall:my-6" v-if="!isAuth">{{$t('choose.language.haveAccount')}} <a href="#" @click="$refs.loginSheet.open()">{{$t('choose.language.logIn')}}</a></p>
            </div>
        </div>

        <login-sheet ref="loginSheet" />
    </f-app-screen>
</template>

<script>
import LocalesService from '@/services/LocalesService'
import LangItem from '@/components/LangItem.vue'
import { Settings } from '@/store'
import AppService from '@/services/AppService'
import NavButton from '@/components/NavButton.vue'
import { Capacitor } from '@capacitor/core'
import AuthService from '@/services/AuthService.js'
import LoginSheet from '@/components/LoginSheet.vue'

function sortLangs (a, b, givenOrder) {
  const aIndex = givenOrder.indexOf(a);
  const bIndex = givenOrder.indexOf(b);

  // If both elements are in the order array, compare their indices
  if (aIndex !== -1 && bIndex !== -1) {
    return aIndex - bIndex;
  }

  // If only a is in the order array, a comes first
  if (aIndex !== -1) {
    return -1;
  }

  // If only b is in the order array, b comes first
  if (bIndex !== -1) {
    return 1;
  }

  // If neither a nor b are in the order array, compare them alphabetically
  return a.localeCompare(b);
}

export default {
  name: 'Language',
  components: {
    LoginSheet,
    NavButton,
    LangItem
  },
  computed: {
    languages () {
      return LocalesService.languages.available
    },
    currentLanguage () {
      return Settings.getLanguage()
    },
    isIOS () {
      return Capacitor.getPlatform() === 'ios'
    },
    isAuth () {
      return AuthService.isAuth()
    }
  },
  data() {
    return {
      selectedLanguage: Settings.getLanguage() ?? LocalesService.getAppLanguage()
    }
  },
  methods: {
    selectLanguage(lang) {
      this.selectedLanguage = lang
    },
    async setUserLanguage (lang) {
      await Settings.setLanguage(lang)
      AppService.registerAppEvent('language_set', lang, { language: lang })
    }
  }
}
</script>
